import React, { useState } from "react";
import axios from "axios";
import { FormControl, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import DefaultButton from "../../../styles/materialButtonStyle";
import MaterialDialog from "../../../styles/materialDialog";
import {
  StyledDialogAction,
  StyledDialogContent,
  StyledDialogHead,
  StyledDialogWrapper
} from "../../../styles/styledDialog";

const MANAGER_TYPES = ["cash", "bank", "crypto"];
const EMPTY_FORM = { name: "", type: "crypto", telegramUserId: "", telegramUsername: "", email: "", projectId: "" };

const TelegramAddManagerDialog = ({ bots, hasBots, currentProjectId, setNotification, onAdded, t }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(EMPTY_FORM);

  const handleOpen = () => {
    const defaultProjectId = currentProjectId || (bots.length === 1 ? String(bots[0].projectId) : "");
    setForm({ ...EMPTY_FORM, projectId: defaultProjectId });
    setOpen(true);
  };

  const handleAdd = () => {
    if (!form.name.trim()) {
      setNotification({ visible: true, type: "error", message: t("managers.errors.nameRequired") });
      return;
    }
    const targetProjectId = form.projectId || currentProjectId;
    if (!targetProjectId) {
      setNotification({ visible: true, type: "error", message: t("managers.errors.projectRequired") });
      return;
    }
    axios.post("/api/telegram/managers", {
      projectId: targetProjectId,
      name: form.name.trim(),
      type: form.type,
      telegramUserId: form.telegramUserId || null,
      telegramUsername: form.telegramUsername || null,
      email: form.email || null,
    }, userAuthenticationConfig()).then(response => {
      if (response.status === 201) {
        setOpen(false);
        setNotification({ visible: true, type: "success", message: t("managers.success.added") });
        onAdded(targetProjectId);
      }
    }).catch(error => {
      setNotification({
        visible: true,
        type: "error",
        message: error?.response?.data?.message || t("managers.errors.add")
      });
    });
  };

  return (
    <>
      <DefaultButton color="success" onClick={handleOpen}>
        {t("managers.add")}
      </DefaultButton>

      <MaterialDialog open={open}>
        <StyledDialogWrapper>
          <StyledDialogHead>
            {t("managers.dialog.addTitle")}
          </StyledDialogHead>
          <StyledDialogContent>
            {hasBots && (
              <FormControl fullWidth>
                <Autocomplete
                  options={bots}
                  value={bots.find(b => String(b.projectId) === form.projectId) || null}
                  onChange={(event, bot) => setForm(f => ({ ...f, projectId: bot ? String(bot.projectId) : "" }))}
                  getOptionLabel={(option) => option.projectName}
                  renderInput={(params) => (
                    <TextField {...params} label={t("bots.dialog.project")} />
                  )}
                  blurOnSelect
                  disableClearable
                />
              </FormControl>
            )}
            <TextField
              label={t("managers.dialog.name")}
              value={form.name}
              onChange={e => {
                const v = e.target.value;
                setForm(f => ({ ...f, name: v }));
              }}
              required
            />
            <FormControl fullWidth>
              <Autocomplete
                options={MANAGER_TYPES}
                value={form.type}
                onChange={(event, type) => setForm(f => ({ ...f, type: type || "crypto" }))}
                getOptionLabel={(option) => option}
                renderInput={(params) => (
                  <TextField {...params} label={t("managers.dialog.type")} />
                )}
                blurOnSelect
                disableClearable
              />
            </FormControl>
            <TextField
              label={t("managers.dialog.telegramUserId")}
              value={form.telegramUserId}
              onChange={e => {
                const v = e.target.value;
                setForm(f => ({ ...f, telegramUserId: v }));
              }}
            />
            <TextField
              label={t("managers.dialog.telegramUsername")}
              value={form.telegramUsername}
              onChange={e => {
                const v = e.target.value;
                setForm(f => ({ ...f, telegramUsername: v }));
              }}
            />
            <TextField
              label={t("managers.dialog.email")}
              value={form.email}
              onChange={e => {
                const v = e.target.value;
                setForm(f => ({ ...f, email: v }));
              }}
              type="email"
            />
          </StyledDialogContent>
          <StyledDialogAction col="2">
            <DefaultButton onClick={() => setOpen(false)} color="danger">
              {t("managers.dialog.cancel")}
            </DefaultButton>
            <DefaultButton onClick={handleAdd} color="success">
              {t("managers.dialog.add")}
            </DefaultButton>
          </StyledDialogAction>
        </StyledDialogWrapper>
      </MaterialDialog>
    </>
  );
};

export default TelegramAddManagerDialog;